<app-loader></app-loader>
<div class="app-wrapper" id="app-wrapper">
  <router-outlet></router-outlet>
</div>
